import React, { useState, useEffect, useRef } from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Productos from './ProductosFacturarPedido';
import ClienteFactura from './ClienteFacturaPedido';
import AlertsFacturas from './Utils/AlertsFacturasPedidos';
import APIserver from '../../../../api/axiosConfig';
import Swal from 'sweetalert2';
import CrearPagoResModal from '../../PagosResibidos/componentes/crearPagoResModal';

function CrearFactura() {
  const [idCliente, setIdCliente] = useState('');
  const [clienteID, setClienteIDs] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const [venceDate, setVenceDate] = useState('');
  const [productos, setProductos] = useState([]);
  const [tipoFactura, setTipoFactura] = useState('');
  const [asesor, setAsesor] = useState('');
  const [envio, setEnvio] = useState(0);
  const [dondePago, setDondePago] = useState('');
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [cantItem, setCantItem] = useState(0);
  const navigate = useNavigate();
  const { idPedido } = useParams(); // Obtener el idPedido de los parámetros de la URL
  const [costoEnvio, setCostoEnvio] = useState(0); // Valor predeterminado en 0
  const [descuento, setDescuento] = useState(0);
  const [formaPago, setformaPago] = useState(() => {
    try {
      return localStorage.getItem('forma_pago_preferida_fac') || 'efectivo';
    } catch (e) {
      return 'efectivo';
    }
  });
  const [transport, settransportadora] = useState(() => {
    try {
      return localStorage.getItem('transportadora_preferida_fac') || '';
    } catch (e) {
      return '';
    }
  });
  const [numGuia, setnumGuia] = useState('');

  const [showPagoModal, setShowPagoModal] = useState(false);
  const [facturaCreada, setFacturaCreada] = useState(null);
  const paymentSavedRef = useRef(false);

  const handleClosePagoModal = (isSaved) => {
    setShowPagoModal(false);
    if (isSaved === true) {
      paymentSavedRef.current = true;
    } else if (!paymentSavedRef.current) {
      navigate('/admin/IngresosFacturas/');
    }
  };

  const handlePagoSuccess = () => {
    paymentSavedRef.current = true;
    setShowPagoModal(false);
    navigate('/admin/IngresosFacturas/');
  };
  useEffect(() => {
    const fetchPedido = async () => {
      if (idPedido) {
        try {
          const response = await APIserver.get(`/api/facturarPedidos/pedidos/${idPedido}`);
          const pedidoData = response.data;
        //  console.log("datos recibidos: ",pedidoData);

          if (pedidoData) {
            setIdCliente(pedidoData.idCliente || '');
            setClienteIDs(pedidoData.clienteID || '');
            setCurrentDate(pedidoData.creacion || '');
            setVenceDate(pedidoData.vence || '');
            setTotal(0);
            setCantItem(pedidoData.totalProductos || 0);
            setCostoEnvio(0); // Inicia en 0 para que el usuario ingrese el costo de envío manualmente
            setDescuento(pedidoData.descuento || 0);

            if (pedidoData.detalles && Array.isArray(pedidoData.detalles)) {
              setProductos(pedidoData.detalles.map((d, index) => ({
                id: d.idDetalle ? `detalle-${d.idDetalle}` : `prod-${d.idProducto || 'item'}-${index}-${Date.now()}-${Math.random()}`,
                idProducto: d.idProducto,
                referencia: d.referencia || '',
                nomProducto: d.nomProducto || '',
                cantidad: d.cantidad || 1,
                valorUnitario: parseFloat(d.valorUnitario || (pedidoData.tipo === 'distribucion' ? d.precioM : d.precioU) || 0),
                stockDisponible: d.stock || 0,
                autoCompleted: !!(d.nomProducto && (parseFloat(d.valorUnitario || 0) > 0 || parseFloat(d.precioU || 0) > 0 || parseFloat(d.precioM || 0) > 0)),
                stockErrorMessage: (d.stock !== undefined && d.cantidad > d.stock)
                  ? `La cantidad pedida (${d.cantidad}) excede el stock (${d.stock}).`
                  : ''
              })));
            } else {
              console.error('Detalles del pedido no están disponibles o no son un arreglo');
            }
          } else {
            console.error('Datos del pedido no están disponibles');
          }
        } catch (error) {
          AlertsFacturas.showErrorMessage('Error al obtener los detalles del pedido');
        }
      }
    };
    fetchPedido();
  }, [idPedido]);

  const validateFacturaData = () => {
    if (!idCliente || !currentDate || !venceDate || !tipoFactura || !asesor || productos.length === 0) {
      AlertsFacturas.showErrorMessage('Por favor complete todos los campos obligatorios.');
      return false;
    }
    return true;
  };

  const handleCreateFactura = async () => {
    if (!validateFacturaData()) return;
    const loadingAlert = Swal.fire({
      title: 'Creando factura...',
      text: 'Por favor, espere un momento.',
      allowOutsideClick: false, // Deshabilitar hacer clic fuera de la alerta
      didOpen: () => {
        Swal.showLoading(); // Mostrar animación de carga
      }
    });

    // Mapea los productos para asegurarte de que cada producto tenga la propiedad 'idProducto' y valorUnitario numérico
    const productosConIdProducto = productos.map(producto => ({
      ...producto,
      idProducto: producto.idProducto ? Number(producto.idProducto) : (Number(producto.id) || null),
      valorUnitario: parseFloat(producto.valorUnitario) || 0
    }));

    const facturaData = {
      idCliente: idCliente,
      creacion: currentDate,
      vence: venceDate,
      totalFacV: total,
      formaPago,
      subtotal,
      dondePago,
      numGuia,
      transport,
      cantItem: cantItem,
      cosEnvio: envio,
      descuento: descuento,
      tipoFactura,
      asesor,
      productos: productosConIdProducto
    };
    //console.log("pedidos a enviar: ", facturaData);
    try {
      // Crear la factura
      const response = await APIserver.post(`/api/facturas`, facturaData);

      // Obtener la fecha y hora actuales
      const fechaEstado = new Date().toISOString().slice(0, 19).replace('T', ' ');

      // Actualizar el estado del pedido a "facturado" y registrar la fecha de facturación
      await APIserver.put(`/api/facturarPedidos/estado/${idPedido}`, {
        estado: 'facturado',
        fechaEstado
      });

      // Cerrar alerta de carga
      Swal.close();

      let numFacV = response.data?.numFacV || response.data?.numeroFactura;
      let idFacV = response.data?.idFacV || response.data?.idFactura;

      // Fallback si por alguna razón no viniera directamente en la respuesta
      if (!numFacV) {
        try {
          const ultFacturaRes = await APIserver.get('/api/Mostrar/facturas?rowsPerPage=1&page=1&sortField=numFacV&sortOrder=DESC');
          if (ultFacturaRes.data?.facturas?.length > 0) {
            const ultima = ultFacturaRes.data.facturas[0];
            numFacV = ultima.numeroFactura || ultima.numFacV;
            idFacV = ultima.idFactura || ultima.idFacV;
          }
        } catch (e) {
          console.warn('No se pudo obtener el último número de factura:', e);
        }
      }

      const infoFactura = {
        numeroFactura: numFacV || '',
        numFacV: numFacV || '',
        idFacV: idFacV,
        idFactura: idFacV
      };
      setFacturaCreada(infoFactura);
      paymentSavedRef.current = false;

      // Alerta de éxito de creación
      await Swal.fire({
        icon: 'success',
        iconColor: '#2fb380',
        title: '¡Éxito!',
        text: numFacV ? `Factura ${numFacV} creada con éxito.` : 'Factura creada con éxito',
        showConfirmButton: false,
        timer: 1800
      });

      // Abrir directamente el modal de pago
      setShowPagoModal(true);
    } catch (error) {
      Swal.close();
      // Verificar si el error tiene un mensaje relacionado con stock insuficiente
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;

        // Verifica si el mensaje de error está relacionado con el stock insuficiente
        if (errorMessage.includes('Stock insuficiente')) {
          AlertsFacturas.showErrorMessage('Error al crear la factura, un producto no tiene stock suficiente.');
        } else {
          // Muestra un mensaje genérico de error si no es un problema de stock
          AlertsFacturas.showErrorMessage('Error al crear la factura');
        }
      } else {
        // Error genérico en caso de que no haya un mensaje de error específico en la respuesta
        AlertsFacturas.showErrorMessage('Error al crear la factura');
      }
    }
  };

  const handleCancel = () => {
    if (
      idCliente ||
      currentDate ||
      venceDate ||
      productos.length > 0 ||
      tipoFactura ||
      formaPago ||
      numGuia ||
      dondePago ||
      transport ||
      dondePago ||
      asesor ||
      envio ||
      descuento ||
      subtotal ||
      total ||
      cantItem
    ) {
      AlertsFacturas.showCancelConfirmation(() => {
        navigate('/admin/Pedidos/');
      });
    } else {
      navigate('/admin/Pedidos/');
    }
  };

  return (
    <div className='mx-2 mt-3 mt-md-0'>
      <div className='m-2 text-center'>
        <Button variant='dark' className='me-2' onClick={handleCancel}>Cancelar</Button>
        <Button variant='danger' className='me-2' onClick={handleCreateFactura}>Crear Factura</Button>
      </div>
      <Card className='shadow-none'>
        <Card.Header className='fw-bold'>
          Detalles de cliente
        </Card.Header>
        <Card.Body>
          <ClienteFactura
            setClienteID={setIdCliente}
            setVenceDate={setVenceDate}
            setTipoFactura={setTipoFactura}
            setAsesor={setAsesor}
            setCreacionDate={setCurrentDate}
            setformaPago={setformaPago}
            settransportadora={settransportadora}
            setnumGuia={setnumGuia}
            setdondePago={setDondePago}
            pedidoId={idPedido} // Pasar idPedido para cargar datos si es necesario
          />
        </Card.Body>
      </Card>
      <Productos
        setProductos={setProductos}
        setSubtotal={setSubtotal}
        setTotal={setTotal}
        setCantItem={setCantItem}
        setEnvio={setEnvio}
        setDescuento={setDescuento}
        tipoFactura={tipoFactura}
        productos={productos} // Pasar los productos con referencia y cantidad
        costoEnvio={costoEnvio} // Asegúrate de que esto no sea undefined
        descuento={descuento}
      />
      <div className='m-2 text-center'>
        <Button variant='dark' className='me-2' onClick={handleCancel}>Cancelar</Button>
        <Button variant='danger' className='me-2' onClick={handleCreateFactura}>Crear Factura</Button>
      </div>

      {/* Modal para agregar pago a la factura recién creada */}
      {showPagoModal && facturaCreada && (
        <CrearPagoResModal
          show={showPagoModal}
          handleClose={handleClosePagoModal}
          factura={facturaCreada}
          onSuccess={handlePagoSuccess}
        />
      )}
    </div>
  );
}

export default CrearFactura;
